module.exports = __webpack_public_path__ + "img/p-01.28720cc2.webp";